import { SmartTable } from '../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($uibModal,Alert) {
	this.$uibModal=$uibModal;
	this.Alert = Alert;
    }

    $onInit() {
        this.st = new SmartTable();
this.label=angular.copy(this.labelGroup);
//this.displayItems=this.companyUsers;
    }


	showRemoveModal() {
        this.$uibModal
            .open({
                component: 'companyUserLabelMembersRemove',
				backdrop: 'static',
                resolve: {
                    companyId: () => this.companyId,
                    userLabelId: () => this.label.id,
                    userIds: () => this.st.selectedIds,
                },
            }).result
            .then(() => {
                const users = this.companyUsers;
                const selectedIds = this.st.selectedIds;
                const filteredUsers = users.filter(({id}) => !selectedIds.includes(id));
                users.splice(0, users.length, ...filteredUsers);
                const key = 'company.user-directories.saaspass-users.user-labels.users.removed';
                const variables = {labelName: this.label.labelName};
                this.Alert('success', key, variables);
            },(res)=>{}).catch(function(error) {});
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/user-labels.controller.js